module.exports = __webpack_public_path__ + "static/media/office-lunch-catering-hero.5473f947.jpg";